<template>
  <div class="export-pdf-container cert-container">
    <div class="box-header">
      <p class="title">OVERALL RATING</p>
    </div>
    <div class="content">
      <div class="box-certificate">
        <img class="certificate-logo" :src="'img/imgPdf/logo-upm.png'" alt="" />
        <p class="cert-program-name">{{ programData.name }}</p>
        <!--        <p class="cert-program-nation">{{ programInfo.nation }}</p>-->
        <p class="cert-program-nation">{{ programData.university_name }}</p>
        <img
          :src="
            `img/icon-certificate/${getStarImg(
              programData.program_type_id === 1 ? 'research' : 'applied',
              programSummaryRatingData.star,
              programSummaryRatingData.extra
            )}`
          "
          alt=""
          class="research-plus"
        />
        <!--        <p class="cert-year">{{ new Date().getFullYear() }}</p>-->
        <p class="cert-program-type">
          {{
            programData.program_type
              ? programData.program_type.name.replace(
                  "Research program",
                  "Research Oriented Program"
                )
              : ""
          }}
        </p>
      </div>
      <div class="box-chieved">
        <div
          class="box-score"
          :class="[{ 'box-score-applied': programData.program_type_id !== 1 }]"
          style=""
        ></div>
        <div class="box-chieved-score">
          <p>
            Achieved score<br />
            {{ programSummaryRatingData.score | formatNumber }}
          </p>
        </div>
        <div class="box-max-score">
          <p>
            Maximum score<br />
            {{ programSummaryRatingData.weight | formatNumber }}
          </p>
        </div>
      </div>
    </div>
    <img class="overall-bottom" :src="'img/imgPdf/bg-certificate.png'" alt="" />
  </div>
</template>

<script>
export default {
  name: "Overall",
  data() {
    return {
      programData: {
        name: "",
        university_name: "",
        nation: "",
        program_type_id: "",
        program_type: {
          name: ""
        }
      },
      programSummaryRatingData: {
        score: 0,
        weight: 0,
        star: 0,
        extra: null
      }
    };
  },
  props: {
    programInfo: {},
    programSummaryRating: {}
  },
  watch: {
    programInfo: {
      handler(newVal) {
        if (!newVal) return;
        this.programData.name = newVal.name;
        this.programData.university_name = newVal.university_name;
        this.programData.nation = newVal.nation;
        this.programData.program_type_id = newVal.program_type_id;
        this.programData.program_type = newVal.program_type;
      },
      deep: true,
      immediate: true
    },
    programSummaryRating: {
      handler(newVal) {
        this.programSummaryRatingData.extra = newVal.extra;
        this.programSummaryRatingData.star = newVal.star;
        this.programSummaryRatingData.score = newVal.score;
        this.programSummaryRatingData.weight = newVal.weight;
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    programTypeName() {
      if (!this.programData) return "";
      switch (this.programData.program_type.name) {
        case "Research program":
          return "Research oriented program";
        case "Applied program":
          return "Applied oriented program";
        default:
          return this.programData.program_type.name;
      }
    }
  },
  created() {
    this.programData.name = this.programInfo.name;
    this.programData.university_name = this.programInfo.university_name;
    this.programData.nation = this.programInfo.nation;
    this.programData.program_type_id = this.programInfo.program_type_id;
    this.programData.program_type = this.programInfo.program_type;
    this.programSummaryRatingData.extra = this.programSummaryRating.extra;
    this.programSummaryRatingData.star = this.programSummaryRating.star;
    this.programSummaryRatingData.score = this.programSummaryRating.score;
    this.programSummaryRatingData.weight = this.programSummaryRating.weight;
  },
  methods: {
    getStarImg(divisionName, star = "", extra = "") {
      const displayStar =
        star && star >= 1 ? Math.floor(star / 1).toFixed(0) : 1;
      return `${divisionName}_${_.toLower(extra)}${displayStar}.png`;
    },
    getCategoryStarImg(divisionName, star = "") {
      const displayStar = star && star >= 1 ? parseInt(star) : 1;
      return `${divisionName}_${displayStar}.svg`;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/program-pdf.scss";
</style>
